import React from 'react';

export default function LoadingSpinner({ message }) {
    return (
        <div className={'loading-spinner flex'}>
            <div>{message || 'Loading'}...</div>
            <div>
                <img src={'/icons/loading.gif'} alt={'loading'} />
            </div>
        </div>
    );
}
